import { memo } from 'react'
import { createStyles } from '@codeleap/styles'
import { isMessageDeleted } from '@packages/chat/src'
import { Touchable, Text } from '@/components'
import { useMessageContext } from 'stream-chat-react'
import { textVariant } from '@/config'
import { useConditionalMessageStyle } from '../hooks'
import { MessageProps } from '../types'
import { Getstream } from '@/services'

const MessageRepliesWithContent = (props: MessageProps) => {
  const { message, threadList } = props
  const { openThread } = Getstream.Chat.useThreadNavigation()
  const repliesCount = message?.reply_count || 0
  const { styles } = useConditionalMessageStyle(baseStyles, myMessageStyles)

  const isThreadParent = threadList && !message?.parent_id

  if (repliesCount === 0 || isMessageDeleted(message) || isThreadParent) return null

  const handlePress = () => {
    openThread(message)
  }

  return (
    <Touchable debugName={`MessageReplies:${message?.id}`} onPress={handlePress}>
      <Text style={styles.repliesText}>{`${repliesCount} replies`}</Text>
    </Touchable>
  )
}

export const MessageReplies = () => {
  const props = useMessageContext()
  return <MessageRepliesWithContent {...props} />
}

const baseStyles = createStyles(theme => ({
  repliesText: {
    ...textVariant(['c1', 'bold']),
    color: theme.baseColors.onPrimarySolid50Heading,
  },
}))

const myMessageStyles = createStyles((theme) => ({
  repliesText: {
    color: theme.baseColors.onPrimarySolid500Heading,
  },
}))
